import { render, staticRenderFns } from "./ZonaCard.vue?vue&type=template&id=50ac75d4&scoped=true"
import script from "./ZonaCard.vue?vue&type=script&lang=js"
export * from "./ZonaCard.vue?vue&type=script&lang=js"
import style0 from "./ZonaCard.vue?vue&type=style&index=0&id=50ac75d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ac75d4",
  null
  
)

export default component.exports